import { ComputedRef } from 'vue'
import { ScrollSpyMenuTypes } from '~/types/scroll-spy-menu-types'

export function useScrollSpy(navigation: ComputedRef<ScrollSpyMenuTypes | undefined>, offset = 20) {
  const nuxtApp = useNuxtApp()
  const elements = ref<Element[]>([])
  const activeHash = ref<string>('')

  onMounted(() => {
    watch(
      navigation,
      (navigations) => {
        getElements(navigations)
        handleScroll()
      },
      { immediate: true, flush: 'post' }
    )
  })

  const { y } = useWindowScroll()

  watch(y, handleScroll)

  function getElements(navigations: ScrollSpyMenuTypes | undefined) {
    if (nuxtApp.ssrContext) return
    elements.value = []
    if (!navigations) return
    for (const navigation of navigations) {
      const docEl = document.getElementById(navigation.href.replace('#', ''))
      if (docEl) elements.value.push(docEl)

      if (navigation?.items) {
        for (const item of navigation.items) {
          const docEl = document.getElementById(item.href.replace('#', ''))
          if (docEl) elements.value.push(docEl)
        }
      }
    }
  }

  function handleScroll() {
    if (!elements.value.length && navigation.value?.length) getElements(navigation.value)

    for (let i = 0; i < elements.value.length; i++) {
      const top1 = i !== 0 ? elements.value[i].getBoundingClientRect().top : -1

      const top2 =
        i !== elements.value.length - 1 ? elements.value[i + 1].getBoundingClientRect().top : Number.MAX_VALUE

      if (top1 < offset && top2 > offset) {
        if (elements.value[i].id) activeHash.value = `#${elements.value[i].id}`
        return
      }
    }
  }

  return {
    activeHash,
  }
}
